/**
 * Google gibi bir OAuth sağlayıcısı Supabase'de kapalıysa (veya kullanıcı
 * reddederse) GoTrue, `redirectTo` adresine `#error=...&error_description=...`
 * (bazen `?error=...`) ekleyerek geri döner. Bu bilgi, AuthProvider ilk mount
 * olduğunda (RequireAdmin oturumsuz kullanıcıyı /login'e yönlendirmeden ÖNCE)
 * okunup state'e alınmalı — yoksa client-side yönlendirme URL'i değiştirince
 * kaybolur.
 */
export function readOAuthError(): string | null {
  if (typeof window === 'undefined') return null;

  const hash = window.location.hash.startsWith('#') ? window.location.hash.slice(1) : '';
  const search = window.location.search.startsWith('?') ? window.location.search.slice(1) : '';
  const params = new URLSearchParams(hash || search);
  const description = params.get('error_description') ?? params.get('error');
  if (!description) return null;

  // Okunduktan sonra URL'den temizle (sayfa yenilenince tekrar görünmesin).
  window.history.replaceState(null, '', window.location.pathname);
  return description.replace(/\+/g, ' ');
}
